import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import settings from '@/middleware/app';
import Axios from 'axios';
import moment from 'moment';
import {getAuthToken,logoutUser,setAuthToken,setAuthLang,getUserInfo} from '@/middleware/auth';
import {onRandom,onBehind} from "@/middleware/hadish";
import {dynamicID} from '@/middleware/dynamicId';
import messages from "@/middleware/i18n";
import VueI18n from "vue-i18n";
import VueSweetalert2 from 'vue-sweetalert2';
import vueJquery from 'vue-jquery';
import VueEvents from 'vue-events';
import accounting from 'accounting';
import VueToast from 'vue-toast-notification';
import VueGoodTablePlugin from 'vue-good-table';
import addFunction from '@/middleware/addFunction';
import money from 'v-money';
import VModal from 'vue-js-modal';
import vSelect from 'vue-select'
import VueMeta from 'vue-meta'
import DisableAutocomplete from 'vue-disable-autocomplete';

// Axios Config Header
Axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
Axios.defaults.headers.common['Accept'] = "application/json";
Axios.interceptors.response.use(function(response){
  return response;
},function(error){
  if (error.response.status === 401) {
    logoutUser();
    window.location.href = '/';
  }else{
    return Promise.reject(error);
  }
});
Vue.config.productionTip = false

Vue.use(VueSweetalert2);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(DisableAutocomplete);
Vue.use(VueToast);
Vue.use(vueJquery);
Vue.use(VueEvents);
Vue.use(VueGoodTablePlugin);
Vue.use(money, {precision: 4});
Vue.use(VModal,{
  dynamicDefaults: {
    draggable: true,
    resizable: true,
    height: 'auto',
    dialog:true,
  }
})
Vue.use(VueI18n);

Vue.component('v-select', vSelect);

Vue.filter('format_number', function (value){
  return parseInt(value).toLocaleString()
})

Vue.prototype.$settings         = settings;
Vue.prototype.$http             = Axios;
Vue.prototype.$accounting       = accounting;
Vue.prototype.$moment           = moment;
Vue.prototype.$getAuthToken     = getAuthToken;
Vue.prototype.$getUserInfo      = getUserInfo;
Vue.prototype.$addFunction      = addFunction;
Vue.prototype.$logoutUser       = logoutUser;
Vue.prototype.$setAuthToken     = setAuthToken;
Vue.prototype.$setAuthLang      = setAuthLang;
Vue.prototype.$onRandom         = onRandom;
Vue.prototype.$onBehind         = onBehind;
Vue.prototype.$dynamicId        = dynamicID;

let lang    = localStorage.Lang;

if (localStorage.getItem("Lang") === null) {
  localStorage.Lang   = "id";
  localStorage.setItem('Lang', "id")
  lang           = "id";
  setAuthLang(lang);
}

const token = getAuthToken();
if (token) {
  setAuthToken(token);
}



const timeoutInMS = 900000; // 15 minutes -> 15 * 60 * 1000
let timeoutId;


function handleInactive() {
  // Here you want to logout a user and/or ping your token
  console.log("logout automatically")
  logoutUser();
  window.location.href = '/';
}

function startTimer() { 
  // setTimeout returns an ID (can be used to start or clear a timer)
  timeoutId = setTimeout(handleInactive, timeoutInMS);
}

function resetTimer() { 
  clearTimeout(timeoutId);
  startTimer();
}

function setupTimers () {
  document.addEventListener("keypress", resetTimer, false);
  document.addEventListener("mousemove", resetTimer, false);
  document.addEventListener("mousedown", resetTimer, false);
  document.addEventListener("touchmove", resetTimer, false);
  startTimer();
}


Vue.prototype.$setupTimers             = setupTimers;


const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'id',
  localeDir: 'locales',
  enableInSFC: true,
  messages,
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
